import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { PageSection } from 'Components/Layout';
import { WorksheetAssociatedTestSection } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import { TestProcedure } from '../../types';

let WashingPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector, namePrefix }) => {
  const isCoarsePortion = namePrefix!.endsWith('WholePortion.Separation.CoarsePortion');
  const isFineSubspecimenPortion = namePrefix!.endsWith('WholePortion.Separation.FinePortion.Subspecimen');

  const isAnnexA = useSelector(
    pipe(createWorksheetSelector!('data.Preparation.Method', false), (m) => m === TestProcedure.AnnexA)
  );

  let heading = 'Washing';
  if (isAnnexA) {
    if (isCoarsePortion) {
      heading = 'Coarse Portion Washing';
    } else if (isFineSubspecimenPortion) {
      heading = 'Fine Portion Subspecimen Washing';
    }
  }

  return (
    <PageSection heading={heading}>
      <WorksheetAssociatedTestSection
        testType="Wash"
        associatedTestModel={{
          measured: true,
        }}
        name="Washing.AssociatedWashTest"
        indented={false}
      />
    </PageSection>
  );
};

WashingPageSection = withInjectedProps(WashingPageSection);

export { WashingPageSection };
export default WashingPageSection;
